<template>
  <div class="modal withdraw-modal success-create-modal">
    <div class="overlay"  @click="$parent.closeNoDealModal"></div>
    <div class="wrapper">
      <div class="container">
        <div class="modal-head">
          <img class="close" @click="$parent.closeNoDealModal" src="./../images/close.svg"/>
          <div class="title">{{ $t('Deal is declined') }}</div>
        </div>
        <div class="modal-body">
          <div class="desc">
            {{ $t('Try again or contact us') }}
          </div>
          <button class="button" @click="$parent.closeNoDealModal">
            <span>[ {{ $t('OK') }} ]</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NoDealModal',
  props: [],
  components: {
   
  },
  data: function() {
    return {
     
    }
  },
  methods: {

  }
}
</script>